<template>
    <div class="f-row">
        <!-- <span class="logo-text">Web.TEC</span> -->
        <img :src="require('../../assets/img/selteclogo.png')">
        <!-- <div class="outer-logo">
            <div class="inner-logo"></div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'Logo',
};
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .logo-text {
        font-weight: 900;
        font-size: 29px;
        font-style: italic;
        padding-right: 15px;
    }

    .outer-logo {
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 21px 42px 0 0;
        border-color: $seltec_color transparent transparent transparent;
        margin-left:-5px;
        margin-top:$spacer_xs;
    }

    .inner-logo {
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: $height_s 8px 0 0;
        border-color: $prim_bg_color transparent transparent transparent;
        margin-top:-$height_s - 1;
    }

    .f-row {
        align-items: center;
        margin-right:10px;

        img {
            height: 100%;
            width: 240px;
        }
    }

    @media screen and (max-width: 400px) {       
        .f-row {
            display:none;
        }
    }
</style>
